var render = function render(){var _vm=this,_c=_vm._self._c;return _c('overlay-wrap',{attrs:{"name":"search"}},[_c('div',{staticClass:"logo"},[_vm._t("logo")],2),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('overlay/SET_OVERLAY', '')}}},[_vm._v("\n    Close\n  ")]),_vm._v(" "),(_vm.overlay === 'search')?_c('search-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }